<template>
  <div v-if="data" class="headline-provider">
    <div class="headline-provider__main">
      <div class="headline-provider__wrap">
        <div class="gradient-box" />

        <div class="headline-provider__img-wrap">
          <img
            :src="params.logo"
            alt="alt"
            :title="params.title"
            class="headline-provider__logo"
          />
        </div>

        <div
          v-if="params.labels && params.labels.length"
          class="headline-provider__labels"
        >
          <UiBadge
            v-for="label in params.labels"
            :key="label.id"
            :style="{
              color: label.textColor,
              backgroundColor: label.backgroundColor,
            }"
            :text="getLangText(label.nameUa, label.nameRu, $i18n)"
            :icon-url="label.iconUrl ? `${$config.cloudUrl}/${label.iconUrl}` : null"
          />
        </div>

        <div class="headline-provider__title-wrap">
          <UiText
            :text="params.title"
            :font="{
              'default': 'promo-heading-2',
              'tablet-album': 'promo-heading-1',
            }"
            color="typography-title02"
            class="headline-provider__title"
          />

          <UiBadge
            size="small"
            :text="params.totalGames"
            type="default"
            background="transparent"
          />
        </div>
      </div>
    </div>

    <div class="headline-provider__nav">
      <slot />
    </div>
  </div>
</template>

<script>
import { getLangText } from '@/components/Lobby/helpers.js'

export default {
  name: 'HeadlineProvider',
  props: {
    data: { type: Object },
  },
  computed: {
    params() {
      const title = this.data.name
      const totalGames = `${this.$tc('lobby.content.games')} ${this.data.totalGames}`
      const logo = `${this.$config.cloudUrl}${this.data.iconUrlBig}`
      const labels = this.data.labels

      return {
        title,
        totalGames,
        logo,
        labels,
      }
    },
  },
  methods: {
    getLangText,
  },
}
</script>

<style lang="scss" scoped>
.headline-provider {
  border-radius: var(--radius-xl);
  background: var(--general-bg-card);

  &__main {
    border-radius: var(--radius-xl);
    background: var(--general-bg-navi);
    backdrop-filter: blur(16px);
    padding: var(--padding-m);
  }

  &__wrap {
    position: relative;
    display: flex;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    padding: var(--padding-xl) var(--padding-m) var(--padding-l) var(--padding-m);
    border-radius: var(--radius-l);
    background: var(--general-bg-card);

    @include media(tablet-album) {
      justify-content: flex-start;
      flex-direction: column;
    }

    &:before {
      position: absolute;
      left: 0;
      top: 0;
      content: '';
      background-image: url('/img/lobby/chess.svg');
      background-size: contain;
      background-repeat: no-repeat;
      width: 210.053px;
      height: 238px;
      border-radius: inherit;
    }

    & > * {
      z-index: 1;
    }
  }

  &__title-wrap {
    text-align: center;
    white-space: nowrap;
    padding-left: var(--spaces-s);

    @include media(tablet-album) {
      text-align: left;
      padding-left: 0;
    }
  }

  &__img-wrap {
    position: relative;
    width: 68px;
    height: 68px;
    border-radius: 50%;

    @include media(tablet-album) {
      width: 120px;
      height: 120px;
    }
  }

  &__logo {
    object-fit: contain;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  &__labels {
    position: absolute;
    right: var(--spaces-s);
    top: 2px;
    display: flex;
    flex-direction: column;
  }

  &__nav {
    padding: var(--spaces-m);
  }
}
</style>
